import { AppAlert } from '@models';

export const ALERT_SLICE = 'alerts';

export interface AlertState {
  alerts: AppAlert[];
}
